import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
    }}
  >
    <h1 style={{ fontSize: 72, margin: 0, color: "#2563eb" }}>404</h1>
    <p style={{ color: "#64748b" }}>Page not found</p>
    <Link to="/home">Go home</Link>
  </div>
);

export default NotFound;
